<script setup lang="ts">
import { onUnmounted, watch } from 'vue'

const props = defineProps<{ modelValue: boolean }>()
const emit = defineEmits<{ 'update:modelValue': [boolean] }>()

function close() {
  emit('update:modelValue', false)
}

watch(
  () => props.modelValue,
  (isOpen) => {
    document.body.style.overflow = isOpen ? 'hidden' : ''
  },
)

onUnmounted(() => {
  document.body.style.overflow = ''
})
</script>

<template>
  <Teleport to="body">
    <div
      class="fixed inset-0 z-40 bg-navy/60 transition-opacity duration-300"
      :class="modelValue ? 'opacity-100' : 'pointer-events-none opacity-0'"
      @click="close"
    />
    <aside
      class="fixed inset-y-0 right-0 z-50 flex w-70 max-w-[80vw] flex-col gap-8 bg-teal px-6 py-8 shadow-2xl transition-transform duration-300"
      :class="modelValue ? 'translate-x-0' : 'translate-x-full'"
    >
      <button
        aria-label="Close menu"
        class="self-end text-2xl leading-none text-cream-text"
        @click="close"
      >
        ✕
      </button>
      <slot />
    </aside>
  </Teleport>
</template>

<style scoped></style>
